import { CONFIG } from '../../core/config';
import { BusinessEntity } from '../business-entity';
import { InspectionPlanTaskMitigationColumn } from './inspection-plan-task-mitigation-column';
import { MitigationPlanTaskSource } from './inspection-plan-task-source';
import { LastInspectionDateSource } from './last-inspection-date-source';
import { MitigationPlanFrequencySource } from './mitigation-plan-frequency-source';

export class Recommendation extends BusinessEntity {
  public recommendationId: string;
  public orgTreeNodeModelRunId: string;
  public inspectionPlanId: string;
  public inspectionPlanTaskId: string;
  public mitigationType: string;
  public rowIndex: number;
  public taskReference: string;
  public taskName: string;
  public taskFrequency: number;
  public frequencySource: MitigationPlanFrequencySource;
  public taskInterval: string;
  public taskExtent: string;
  public dueDate: string;
  public isStaticDueDate: boolean;
  public included: boolean;
  public sourceType: MitigationPlanTaskSource;
  public canToggle: boolean;
  public installationDate: Date;
  public lastInspectionId: string;
  public lastInspectionDate: string;
  public lastInspectionDateSource: LastInspectionDateSource;

  public flagtaskInterval: boolean;
  public flagtaskFrequency: boolean;
  public flagtaskExtent: boolean;
  public flagtaskName: boolean;
  public flagmitigationType: boolean;
  public flagRow: boolean;

  public mitigationSource: boolean;
  public overrideFrequency: boolean;
  public lastInspectionDateOverriden: boolean;

  public sendToErp: boolean;
  public erpMaintenancePlanNumber: string;
  public erpNotificationNumber: string;
  public erpNotificationSystemStatus: string;
  public erpWorkOrderNumber: string;
  public erpWorkOrderSystemStatus: string;
  public erpNotificationUserStatus: string;
  public erpPackageNumber: string;
  public erpMaintenanceItemNumber: string;
  public erpWorkOrderUserStatus : string;


  // used in recommendation
  public mitigationRowId: string;

  public recommendationIncluded: boolean = false;

  public displayedMitigationColumns: string;
  public mitigationColumns: InspectionPlanTaskMitigationColumn[] = [];

  public masterInspectionMethodId: string;
  public masterInspectionMethodName: string;

  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Recommendation';
    this.apiRoute = CONFIG.apiRoutes.recommendations;
  }

  public json() {
    return this;
  }

  public loadFromJson(data) {
    super.loadFromJson(data);
    this.recommendationId = data.recommendationId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.inspectionPlanId = data.inspectionPlanId;
    this.inspectionPlanTaskId = data.inspectionPlanTaskId;
    this.mitigationType = data.mitigationType;
    this.rowIndex = data.rowIndex;
    this.taskReference = data.taskReference;
    this.taskName = data.taskName;
    this.taskFrequency = data.taskFrequency == null ? data.taskFrequency : +(+data.taskFrequency.toFixed(2));
    this.frequencySource = data.frequencySource;
    this.taskInterval = data.taskInterval;
    this.taskExtent = data.taskExtent;
    this.dueDate = data.dueDate;
    this.isStaticDueDate = data.isStaticDueDate;
    this.sourceType = data.sourceType;
    this.installationDate = data.installationDate;
    this.lastInspectionId = data.lastInspectionId;
    this.lastInspectionDate = data.lastInspectionDate;
    this.lastInspectionDateSource = data.lastInspectionDateSource;
    this.mitigationSource = data.mitigationSource;
    this.overrideFrequency = data.overrideFrequency;
    this.lastInspectionDateOverriden = data.lastInspectionDateOverriden;

    this.sendToErp = data.sendToErp;
    this.erpMaintenancePlanNumber = data.erpMaintenancePlanNumber;
    this.erpNotificationNumber = data.erpNotificationNumber;
    this.erpNotificationSystemStatus = data.erpNotificationSystemStatus;
    this.erpWorkOrderNumber = data.erpWorkOrderNumber;
    this.erpWorkOrderSystemStatus = data.erpWorkOrderSystemStatus;
    this.erpNotificationUserStatus = data.erpNotificationUserStatus;

    this.mitigationRowId = data.mitigationRowId;
    this.erpPackageNumber = data.erpPackageNumber;
    this.erpMaintenanceItemNumber = data.erpMaintenanceItemNumber;
    this.erpWorkOrderUserStatus = data.erpWorkOrderUserStatus;
    this.displayedMitigationColumns = data.displayedMitigationColumns;
    this.mitigationColumns = [];
    if (data.mitigationColumns) {
      for (const mitigationColumn of data.mitigationColumns) {
        const newMitigationColumn = new InspectionPlanTaskMitigationColumn();
        newMitigationColumn.loadFromJson(mitigationColumn);
        this.mitigationColumns.push(newMitigationColumn);
      }
    }

    this.masterInspectionMethodId = data.masterInspectionMethodId;
    this.masterInspectionMethodName = data.masterInspectionMethodName;

    this.setPermissions();
  }

  public setPermissions() {
    super.setPermissions();
    this.canEdit = true;
    this.canToggle = this.sourceType === MitigationPlanTaskSource.Recommendation;
  }

  public toggleRecommendation(): void {
    this.recommendationIncluded = !this.recommendationIncluded;
  }
}
